import { render, staticRenderFns } from "./GiftTest.vue?vue&type=template&id=08d87953&"
import script from "./GiftTest.vue?vue&type=script&lang=js&"
export * from "./GiftTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports